
const SkillsData = [
    {
        title: "HTML",
    },
    {
        title: "CSS",
    },
    {
        title: "JavaScript",
    },
    {
        title: "PHP",
    },
    {
        title: "ReactJS",
    },
    {
        title: "Tailwind-CSS",
    },
    {
        title: "MongoDB",
    },
    {
        title: "NodeJS",
    },
    {
        title: "Postman",
    },
]
export default SkillsData;